import {Slider} from "antd";
import {useEffect, useState} from "react";
import Icons from "../icons/Icons";
import {useTranslation} from "react-i18next";
import { Tooltip } from 'antd';


export default ({curInstr, setCurInstr, trace, breakPoints}) => {
  const { t } = useTranslation();
  const[marks, setMarks] = useState({});
  const[breakSteps, setBreakSteps] = useState([]);

  const total = trace.length;
  useEffect(() => {
    let breakSteps = []
    let newMarks = breakPoints.reduce((acc, num) => {
      trace.forEach((item, index) => {
        if (item.line === num) {
          acc[index + 1] = ' ';
          breakSteps.push(index)
        }
      });
      return acc;
    }, {});
    setBreakSteps(breakSteps)
    setMarks(newMarks)
  }, [breakPoints]);
  const getNextBreakStep = () => {
    const breakStepArr = Object.keys(marks)
      .map(key => Number(key)) // 将键转换为数字
      .sort((a, b) => a - b);
    let lasts = breakStepArr.filter(step => step > curInstr + 1);
    if (lasts.length < 1) {
      return 0;
    }
    return Math.min(... lasts)
  }

  function stepOver() {
    if (trace[curInstr+1]?.event === 'call'){
      let deep = 1
      for (let i = curInstr+2; i < trace.length; i++) {
        if (trace[i].event === 'return'){
          deep --
        }else if (trace[i].event === 'call'){
          deep ++
        }
        if (breakSteps.includes(i)){
          setCurInstr(i)
          return
        }
        if (deep === 0){
          setCurInstr(Math.min(i+1, trace.length-1))
          return
        }
      }
    }
    setCurInstr(curInstr + 1)
  }
  function stepOut() {
    let deep = 1
    for (let i = curInstr + 1; i < trace.length; i++) {
      if (trace[i].event === 'return'){
        deep --
      }else if (trace[i].event === 'call'){
        deep ++
      }
      if (breakSteps.includes(i)){
        setCurInstr(i)
        return
      }
      if (deep === 0){
        setCurInstr(Math.min(i+1, trace.length-1))
        return
      }
    }
    setCurInstr(trace.length-1)
  }

  return (
    <>
      <div id="navControlsDiv">
        <Slider min={1}
                max={total}
                style={{margin: "0 60px"}}
                marks={marks}
                value={curInstr + 1}
                onChange={(value) => setCurInstr(value - 1)}
        />

        <div id="executionSlider" className="ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all"
             style={{ fontSize: "0.9em" }}>
          <span className="ui-slider-handle ui-state-default ui-corner-all" tabIndex="0"
               style={{ left: "8.66667%", width: "0.8em", height: "1.4em" }}></span>
        </div>
        <div className="vcrControls">
          <Tooltip title={t('GotoFirst')}>
          <button type="button" onClick={() => setCurInstr(0)}
                  disabled={curInstr <= 0 || total <= 0}>┃◀
          </button>
          </Tooltip>
          <Tooltip title={t('GoBack')}>
          <button type="button" onClick={() => setCurInstr(curInstr - 1)} title={t('GoBack')}
                  disabled={curInstr <= 0}>◀
          </button>
          </Tooltip>
          <div id="curInstr" style={{whiteSpace: "nowrap"}}>( {curInstr + 1} / {total} )</div>
          <Tooltip title={t('StepOver')}>
          <button type="button" onClick={stepOver}
                  disabled={curInstr >= total - 1}> <Icons.StepOver/> </button>
          </Tooltip>
          <Tooltip title={t('StepInto')}>
          <button type="button" onClick={() => setCurInstr(curInstr + 1)} title={t('StepInto')}
                  disabled={curInstr >= total - 1}> <Icons.StepInto/> </button>
          </Tooltip>
          <Tooltip title={t('StepOut')}>
          <button type="button" onClick={stepOut} title={t('StepOut')}
                  disabled={curInstr >= total - 1}> <Icons.StepOut/> </button>
          </Tooltip>
          <Tooltip title={t('StepToBreakpoint')}>
          <button  className="stepToBreakPoint" type="button" onClick={()=>setCurInstr(getNextBreakStep()-1)}
            disabled={getNextBreakStep() <= 1}>▶<font>●</font> </button>
          </Tooltip>
          <Tooltip title={t('GotoEnd')}>
          <button type="button" onClick={() => setCurInstr(total - 1)}
                  disabled={total <= 0 || curInstr >= total - 1}>▶┃</button>
          </Tooltip>
        </div>


        <div id="errorOutput" style={{display: "none"}}></div>

      </div>
    </>
  )
}